import type { PhieuChi, PhieuChiInput } from '@/types/schemas';
import { FormMode } from '@/types/form';
import { useRouter } from '@/routing';

interface UsePhieuChiMutationParams {
  formMode: FormMode;
  selectedObj: PhieuChi | null | undefined;
  shouldEditWithUpdatedData: boolean;
  editPhieuChiUuid?: string | null;
  addItem: (data: PhieuChiInput) => Promise<PhieuChi>;
  updateItem: (uuid: string, data: PhieuChiInput) => Promise<PhieuChi>;
  deleteItem: (uuid: string) => Promise<void>;
  handleCloseForm: () => void;
  clearSelection: () => void;
  refreshData: () => Promise<void>;
}

export const usePhieuChiMutation = ({
  formMode,
  selectedObj,
  shouldEditWithUpdatedData,
  editPhieuChiUuid,
  addItem,
  updateItem,
  deleteItem,
  handleCloseForm,
  clearSelection,
  refreshData
}: UsePhieuChiMutationParams) => {
  const router = useRouter();

  const handleCloseEditWithUpdatedData = () => {
    router.back();
  };

  const handleSubmit = async (data: PhieuChiInput) => {
    if (shouldEditWithUpdatedData && editPhieuChiUuid) {
      await updateItem(editPhieuChiUuid, data);
    } else if (formMode === 'add') {
      await addItem(data);
    } else if (formMode === 'edit' && selectedObj?.uuid) {
      await updateItem(selectedObj.uuid, data);
    }

    if (shouldEditWithUpdatedData) {
      handleCloseEditWithUpdatedData();
      return;
    }

    handleCloseForm();
    clearSelection();
    await refreshData();
  };

  return {
    handleSubmit,
    handleDelete: deleteItem,
    handleCloseEditWithUpdatedData
  };
};
